<template>
  <div>
    <div class="store-list-main" v-if="list.length>0">
      <div v-for="(item, index) in list" :key="index" class="store-list-item">
        <img class="store-item-img" :src="item.cover" v-if="item.cover" />
        <div class="store-item-title">
          <div class="store-item-name h3">{{ item.shopName || item.dealerName }}</div>
          <div class="store-item-des h4">{{ item.experienceAddr || item.dealerAddress }}</div>
          <div class="store-item-des h4">{{ item.telephone || "" }}</div>
        </div>
      </div>
    </div>
    <div v-else class="store-no-list">
      <img src="https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20210917110543476-1.png" />
      <span>门店正在招募中</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreList",
  props: {
    list: Array
  }
};
</script>
<style lang="scss" scoped>
@import "@style/base";

@include setMedia($lg) {
  @include setThemeClass {
    .store-list-main {
      padding-bottom: 24px;
      margin-left: -24px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .store-list-item {
        width: 504px;
        height: 160px;
        background-color: getThemeVal(backgroundColorWhite);
        border-radius: 4px;
        margin-left: 24px;
        display: flex;
        flex-direction: row;
        margin-top: 24px;
        .store-item-title {
          display: flex;
          flex-direction: column;
          justify-content: left;
          margin: 20px;
          .store-item-name {
            margin-bottom: 10px;
            font-weight: bold;
          }
          .store-item-des {
            margin-bottom: 10px;
            word-break: break-all;
            white-space: normal;
            text-overflow: ellipsis;
          }
        }
        .store-item-img {
          width: 160px;
          height: 120px;
          margin: 20px 0 20px 20px;
          object-fit: cover;
        }
      }
    }
    .store-no-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: bold;
      img {
        width: 72px;
        margin-top: 80px;
        margin-bottom: 15px;
      }
    }
  }
}

@include setMedia($md) {
  @include setThemeClass {
    .store-list-main {
      .store-list-item {
        width: $sm;
        height: auto;
        display: flex;
        justify-content: flex-start;
        .store-item-title {
          .store-item-name {
          }
          .store-item-des {
          }
        }
        .store-item-img {
          width: 185px;
          height: 120px;
        }
      }
    }
    .store-no-list {
      img {
        margin-top: 270px;
      }
    }
  }
}

@include setMedia($sm) {
  @include setThemeClass {
    .store-list-main {
      .store-list-item {
        width: 100%;
        height: auto;
        flex-direction: column;
        display: flex;
        .store-item-title {
          margin-left: 20px;
          height: 122px;
        }
        .store-item-img {
          width: 160px;
          height: 120px;
          margin: 20px 20px 0 20px;
        }
      }
    }
    .store-no-list {
      img {
        margin-top: 150px;
      }
    }
  }
}
</style>
